import { useEffect, useRef, useState, type FormEvent } from "react";

export function LoginPage({ onSuccess }: { onSuccess: (user: string) => void }) {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [shake, setShake] = useState(false);
  const [mounted, setMounted] = useState(false);
  const userRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const t = window.setTimeout(() => setMounted(true), 60);
    userRef.current?.focus();
    return () => window.clearTimeout(t);
  }, []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const r = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user: user.trim(), password }),
      });
      if (!r.ok) {
        const d = (await r.json().catch(() => ({}))) as { error?: string };
        throw new Error(d.error || "Ошибка входа");
      }
      const d = (await r.json()) as { user: string };
      onSuccess(d.user);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setShake(true);
      window.setTimeout(() => setShake(false), 500);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-screen">
      <div className="login-bg" aria-hidden="true">
        <div className="login-radar">
          <div className="login-radar-ring r1" />
          <div className="login-radar-ring r2" />
          <div className="login-radar-ring r3" />
          <div className="login-radar-ring r4" />
          <div className="login-radar-sweep" />
          <div className="login-radar-blip b1" />
          <div className="login-radar-blip b2" />
          <div className="login-radar-blip b3" />
          <div className="login-radar-core" />
        </div>
        <div className="login-grid" />
        <div className="login-glow" />
      </div>

      <form
        className={`login-card${mounted ? " is-in" : ""}${shake ? " is-shake" : ""}`}
        onSubmit={(e) => void submit(e)}
      >
        <div className="login-brand">
          <div className="radar-dot" />
          <div>
            <h1>ВКУРСЕ</h1>
            <small>МОНИТОРИНГ БРЕНДА</small>
          </div>
        </div>
        <p className="login-sub">Вы в курсе о вашем бренде в интернете</p>

        <label className="login-field">
          <span>Логин</span>
          <input
            ref={userRef}
            value={user}
            onChange={(e) => setUser(e.target.value)}
            autoComplete="username"
            placeholder="vkourse"
            disabled={busy}
          />
        </label>
        <label className="login-field">
          <span>Пароль</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            placeholder="••••••••"
            disabled={busy}
          />
        </label>

        {error ? (
          <div className="login-error" role="alert">
            {error}
          </div>
        ) : null}

        <button className="btn primary login-btn" disabled={busy || !user.trim() || !password}>
          {busy ? "Вход…" : "Войти"}
        </button>
        <div className="login-foot">self-hosted · live</div>
      </form>
    </div>
  );
}
